import { en } from './en';
import { pl } from './pl';
import { ru } from './ru';
import { uk } from './uk';
import type { Language, Translation } from './types';

export const languages: Language[] = ['pl', 'en', 'uk', 'ru'];

export const translations: Record<Language, Translation> = {
  pl,
  en,
  uk,
  ru
};

export const isLanguage = (value: string | null): value is Language =>
  value === 'pl' || value === 'en' || value === 'uk' || value === 'ru';

export type { Language, Translation };
